module.exports = __webpack_public_path__ + "static/Crea_f-db4afd5834ae9f4e84a449e39392e7b9.jpg";